export const getFilteredAndSortedStudents = (
  studentInfoAdminDict,
  studentSearch,
  completedModuleFilters,
  sortConfig
) => {
  return Object.entries(studentInfoAdminDict)
    .filter(([, student]) => {
      const search = studentSearch.toLowerCase().trim();
      const first = student.student_first_name.toLowerCase();
      const last = student.student_last_name.toLowerCase();
      const matchesName = first.startsWith(search) || last.startsWith(search);

      const matchesModules =
        completedModuleFilters.length === 0 ||
        completedModuleFilters.every(moduleId =>
          (student.num_completed_passages?.[moduleId] ?? 0) >= 2
        );

      return matchesName && matchesModules;
    })
    .sort(([, a], [, b]) => {
      const { moduleId, metric, direction } = sortConfig;

      if (metric === 'student_name') {
        const lastNameCompare = a.student_last_name.localeCompare(b.student_last_name);
        if (lastNameCompare !== 0) return direction === 'asc' ? lastNameCompare : -lastNameCompare;
        return direction === 'asc'
          ? a.student_first_name.localeCompare(b.student_first_name)
          : b.student_first_name.localeCompare(a.student_first_name);
      } else if (metric === 'total_completed_passages') {
        const aValue = a.total_completed_passages ?? 0;
        const bValue = b.total_completed_passages ?? 0;
        return direction === 'asc' ? aValue - bValue : bValue - aValue;
      } else if (metric === 'total_failed_passages') {
        const aValue = a.total_failed_passages ?? 0;
        const bValue = b.total_failed_passages ?? 0;
        return direction === 'asc' ? aValue - bValue : bValue - aValue;
      } else if (moduleId && metric) {
        const getValue = student => {
          switch(metric) {
            case 'passed': return student.num_completed_passages?.[moduleId] ?? 0;
            case 'failed': return student.num_failed_passages?.[moduleId] ?? 0;
            case 'begun': return student.num_attempted_passages?.[moduleId] ?? 0;
            default: return 0;
          }
        };
        const aValue = getValue(a);
        const bValue = getValue(b);
        return direction === 'asc' ? aValue - bValue : bValue - aValue;
      }

      // Default sort
      const lastNameCompare = a.student_last_name.localeCompare(b.student_last_name);
      return lastNameCompare !== 0
        ? lastNameCompare
        : a.student_first_name.localeCompare(b.student_first_name);
    });
};

export const generateCSVContent = (filteredStudents, activeModules) => {
  // Sort modules by module_id to ensure consistent order
  const sortedModules = [...activeModules].sort((a, b) => a.module_id - b.module_id);
 
  const headers = [
    'Student Last Name',
    'Student First Name',
    'Total Dialogues Passed',
    'Total Dialogues Failed',
    ...sortedModules.flatMap(module => [
      `Module ${module.module_id} (${module.module_name}) Begun`,
      `Module ${module.module_id} (${module.module_name}) Passed`,
      `Module ${module.module_id} (${module.module_name}) Failed`
    ])
  ];

  const csvRows = filteredStudents.map(([, student]) => {
    const row = [
      student.student_last_name,
      student.student_first_name,
      student.total_completed_passages ?? 0,
      student.total_failed_passages ?? 0,
      ...sortedModules.flatMap(module => [
        student.num_attempted_passages?.[module.module_id] ?? 0,
        student.num_completed_passages?.[module.module_id] ?? 0,
        student.num_failed_passages?.[module.module_id] ?? 0
      ])
    ];
    return row.join(',');
  });

  return [headers.join(','), ...csvRows].join('\n');
};
